import axios from "axios";
import { ListFieldsKeys } from "src/api/config";
import { listMap } from "src/api/config/systemSwitch";
import { DeleteItemRequestProps } from "src/modules/modules.type";
import { strapiUrl } from "src/modules/users/constants";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";

export const deleteItemRequest = <K extends ListFieldsKeys>({
  listName,
  ID,
  Ids,
  anySite,
  fileField,
}: DeleteItemRequestProps<K>) => {
  return new Promise(async (resolve, reject) => {
    const listStrapiApi = listMap[listName].replace(":folder", "");

    let token: string | null = null;

    if (!isPWA()) {
      const result = await SecureStoragePlugin.get({ key: 'accessToken' });
      token = result.value;
    }

    const headers = {
      Accept: "application/json;odata=nometadata",
      "Content-Type": "application/json;odata=nometadata",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    if (Ids && Ids.length > 0) {
      if (fileField) {
        let requests: any = [];
        Ids.forEach((obj) => {
          requests = [
            ...requests,
            axios.get(
              `${strapiUrl}${listStrapiApi}?populate=${fileField}&filters[id][$eq]=${obj.ID}`,
              {
                headers,
                withCredentials: true,
              }
            ),
          ];
        });
        Promise.all(requests).then((values) => {
          console.log("GET_DELETE_MULTI_ELEMENTS_STRAPI: ", values);
          let filesIds: number[] = [],
            elemIds: number[] = [];
          values.forEach((value) => {
            let elem = value.data.data[0];
            let fileId = elem[fileField]["id"];
            let elemId = elem["documentId"];
            filesIds = [...filesIds, fileId];
            elemIds = [...elemIds, elemId];
          });
          requests = [];
          filesIds.forEach((fileId) => {
            requests = [
              ...requests,
              axios.delete(`${strapiUrl}upload/files/${fileId}`, {
                headers,
                withCredentials: true,
              }),
            ];
          });
          Promise.all(requests).then((values) => {
            console.log("DELETE_MULTI_FILES_STRAPI: ", values);
            requests = [];
            elemIds.forEach((id) => {
              requests = [
                ...requests,
                axios.delete(`${strapiUrl}${listStrapiApi}/${id}`, {
                  headers,
                  withCredentials: true,
                }),
              ];
            });
            Promise.all(requests).then((values) => {
              console.log("DELETE_MULTI_ELEMENTS_STRAPI: ", values);
              resolve(Ids.map((obj) => obj.ID));
            });
          });
        });
      } else {
        let requests: any = [];
        Ids.forEach((obj) => {
          requests = [
            ...requests,
            axios.get(
              `${strapiUrl}${listStrapiApi}?filters[id][$eq]=${obj.ID}`,
              {
                headers,
                withCredentials: true,
              }
            ),
          ];
        });
        Promise.all(requests).then((values) => {
          console.log("GET_DELETE_MULTI_ELEMENTS_STRAPI: ", values);
          requests = [];
          values.forEach((value) => {
            const documentID = value.data.data[0]["documentId"];
            requests = [
              ...requests,
              axios.delete(`${strapiUrl}${listStrapiApi}/${documentID}`, {
                headers,
                withCredentials: true,
              }),
            ];
          });
        });
        Promise.all(requests).then((values) => {
          console.log("DELETE_MULTI_ELEMENTS_STRAPI: ", values);
          resolve(Ids.map((obj) => obj.ID));
        });
      }
    } else if (Ids?.length === 0) {
      resolve(null);
    } else {
      if (fileField) {
        axios
          .get(
            `${strapiUrl}${listStrapiApi}?populate=${fileField}&filters[id][$eq]=${ID}`,
            {
              headers,
              withCredentials: true,
            }
          )
          .then((value) => {
            console.log("GET_DELETE_SINGLE_ELEMENTS_STRAPI: ", value);
            let elem = value.data.data[0];
            let documentId = elem["documentId"];
            let fileId = elem[fileField]["id"];
            axios
              .delete(`${strapiUrl}upload/files/${fileId}`, {
                headers,
                withCredentials: true,
              })
              .then((value) => {
                console.log("DELETE_SINGLE_FILE_STRAPI: ", value);
                axios
                  .delete(`${strapiUrl}${listStrapiApi}/${documentId}`, {
                    headers,
                    withCredentials: true,
                  })
                  .then((value) => {
                    console.log("DELETE_SINGLE_ELEMENT_STRAPI: ", value);
                    resolve([ID]);
                  });
              });
          });
      } else {
        axios
          .get(`${strapiUrl}${listStrapiApi}?filters[id][$eq]=${ID}`, {
            headers,
            withCredentials: true,
          })
          .then((value) => {
            let elem = value.data.data[0];
            let documentId = elem["documentId"];
            axios
              .delete(`${strapiUrl}${listStrapiApi}/${documentId}`, {
                headers,
                withCredentials: true,
              })
              .then(() => {
                resolve([ID]);
              });
          });
      }
    }
  });
};
